import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface EmployeeDisplayInfo {
  name: string
  department?: string
  pictureUrl?: string
}

interface BonificacaoState {
  selectedEmployeeId: string | null
  selectedYear: number
  currentAssessmentId: string | null
  filterDepartment: string
  filterStatus: string
  filterSearch: string
  selectedEmployeeInfo: EmployeeDisplayInfo | null

  setSelectedEmployee: (id: string | null) => void
  setYear: (year: number) => void
  setAssessment: (id: string | null) => void
  setFilters: (filters: Partial<{ department: string; status: string; search: string }>) => void
  setSelectedEmployeeInfo: (info: EmployeeDisplayInfo | null) => void
  reset: () => void
}

const initialState = {
  selectedEmployeeId: null as string | null,
  selectedYear: 2026,
  currentAssessmentId: null as string | null,
  filterDepartment: '',
  filterStatus: '',
  filterSearch: '',
  selectedEmployeeInfo: null as EmployeeDisplayInfo | null,
}

export const useBonificacaoStore = create<BonificacaoState>()(
  persist(
    (set) => ({
      ...initialState,

      setSelectedEmployee: (id) => set({ selectedEmployeeId: id }),
      setYear: (year) => set({ selectedYear: year }),
      setAssessment: (id) => set({ currentAssessmentId: id }),
      setFilters: (filters) =>
        set((state) => ({
          filterDepartment: filters.department ?? state.filterDepartment,
          filterStatus: filters.status ?? state.filterStatus,
          filterSearch: filters.search ?? state.filterSearch,
        })),
      setSelectedEmployeeInfo: (info) => set({ selectedEmployeeInfo: info }),
      reset: () => set(initialState),
    }),
    {
      name: 'bonificacao-store',
      partialize: (state) => ({
        selectedEmployeeId: state.selectedEmployeeId,
        selectedYear: state.selectedYear,
        currentAssessmentId: state.currentAssessmentId,
        selectedEmployeeInfo: state.selectedEmployeeInfo,
      }),
    }
  )
)

// Dev-only: expose store for E2E tests to set assessment/employee state directly
if (import.meta.env.DEV) {
  ;(window as any).__bonificacaoStore = useBonificacaoStore
}
